export default [
  {
    path: '/pickup-histories',
    name: 'pickup-history',
    meta: { requiresAuth: true },
    component: () => import('@/pages/pickup-history/index.vue')
  }
]
